import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VueAxios from 'vue-axios';
import {resourceModule} from '@reststate/vuex';
import {VueAuthenticate} from 'vue-authenticate';
import router from './router';
import PermissionChecker from "./plugins/gate";

Vue.use(Vuex);
Vue.use(VueAxios, axios);

const vueAuth = new VueAuthenticate(Vue.prototype.$http, {
    baseUrl: process.env.VUE_APP_LOGIN_API,
    loginUrl: 'login',
});

const token = localStorage.getItem('token');
if (token) {
    Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token;
}
Vue.prototype.$http.defaults.headers.common['Content-Type'] = 'application/vnd.api+json';
Vue.prototype.$http.defaults.headers.patch['Content-Type'] = 'application/vnd.api+json';



const httpClient = Vue.axios.create({
    baseURL: process.env.VUE_APP_API,
    headers: {'Content-Type': 'application/vnd.api+json'},
});

export default new Vuex.Store({
    modules: {
        products: resourceModule({name: 'products', httpClient}),
        productCategories: resourceModule({name: 'product-categories', httpClient}),
        productTypes: resourceModule({name: 'product-types', httpClient}),
        productReleaseTypes: resourceModule({name: 'product-release-types', httpClient}),
        users: resourceModule({name: 'users', httpClient}),
        departments: resourceModule({name: 'departments', httpClient}),
        releaseFlows: resourceModule({name: 'release-flows', httpClient}),
        releaseSteps: resourceModule({name: 'release-steps', httpClient}),
        releases: resourceModule({name: 'releases', httpClient}),
        releaseHistories: resourceModule({name: 'release-histories', httpClient}),
        releaseStepHistories: resourceModule({name: 'release-step-histories', httpClient}),
        releaseImages: resourceModule({name: 'release-images', httpClient}),
        roles: resourceModule({name: 'roles', httpClient}),
        maintainer: resourceModule({name: 'maintainer', httpClient}),
    },
    // You can use it as state property
    state: {
        token: localStorage.getItem('token') || '',
        roles: JSON.parse(localStorage.getItem('roles')) || [],
        user: JSON.parse(localStorage.getItem('user')) || [],
        status: '',
        loader: false,
        httpClient: httpClient,
    },

    // You can use it as a state getter function (probably the best solution)
    getters: {
        httpClient: httpClient,
        isLoggedIn: state => !!state.token,
        authStatus: state => state.status,
    },
    // Mutation for when you use it as state property
    mutations: {
        auth_success(state, token, user) {
            state.status = 'success';
            state.token = token;
            state.user = user;
        },
        auth_error(state) {
            state.status = 'error';
        },
        logout(state) {
            state.status = '';
            state.token = '';
        },
        loader(state, payload) {
            state.loader = payload;
        },
    },
    actions: {
        // Perform VueAuthenticate login using Vuex actions
        login(context, payload) {
            vueAuth.login(payload.user, payload.requestOptions).then((response) => {
                const token = response.data.token;
                const user = response.data.me;

                Vue.prototype.$user.set(response.data.me);
                Vue.prototype.$gate = new PermissionChecker();
                response.data.me.roles[0].permissions.forEach((item) => {
                    Vue.prototype.$gate.add(item.name);
                });

                localStorage.setItem('token', token);
                localStorage.setItem('roles', JSON.stringify(Vue.prototype.$gate.getAll()));
                localStorage.setItem('user', JSON.stringify(Vue.prototype.$user.get()));

                Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                context.commit('auth_success', token, user);
                router.push('/home');
            });
        },
        logout({commit}) {
            return new Promise((resolve, reject) => {
                commit('logout');
                localStorage.removeItem('token');
                localStorage.removeItem('user');
                localStorage.removeItem('roles');
                delete axios.defaults.headers.common['Authorization'];
                resolve();
                router.push('/login');
            });
        },
    },
});

